var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "graph",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37816",
    "data-name": "Group 37816",
    transform: "translate(3.883 18.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52933",
    "data-name": "Path 52933",
    d: "M220.656,591.7H216.1a.1.1,0,0,0-.1.1v10.681h4.758V591.8A.1.1,0,0,0,220.656,591.7Z",
    transform: "translate(-215.505 -591.199)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37815",
    "data-name": "Group 37815",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52934",
    "data-name": "Path 52934",
    d: "M205.985,576.356h-3.344c-.4,0-.81-.026-1.208,0a.623.623,0,0,0-.591.659v8.062c0,.836-.02,1.675,0,2.511v.036a.5.5,0,0,0,.49.49h4.758a.5.5,0,0,0,.49-.49v-10.42c0-.349-.016-.748-.46-.836a.491.491,0,0,0-.261.947l-.046-.02-.176-.176c-.072-.1-.036-.251-.036-.1v10.606l.49-.49h-4.758l.49.49V576.973c-.007-.088.059.007-.036.15l-.176.176c-.144.1-.235.029-.147.036a.971.971,0,0,0,.1,0h4.428a.5.5,0,0,0,.49-.49A.5.5,0,0,0,205.985,576.356Z",
    transform: "translate(-200.833 -576.345)",
    fill: "#f45e29"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37818",
    "data-name": "Group 37818",
    transform: "translate(13.126 7.513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52935",
    "data-name": "Path 52935",
    d: "M471.856,268.4H467.3a.1.1,0,0,0-.1.1v21.238h4.758V268.5A.1.1,0,0,0,471.856,268.4Z",
    transform: "translate(-466.703 -267.909)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37817",
    "data-name": "Group 37817",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52936",
    "data-name": "Path 52936",
    d: "M457.131,253.357h-4.219c-.108,0-.219,0-.327,0a.613.613,0,0,0-.6.6c-.016.34,0,.686,0,1.025v18.93c0,.4-.006.81,0,1.215v.052a.5.5,0,0,0,.49.49h4.758a.5.5,0,0,0,.49-.49V256.407c0-.813.033-1.633,0-2.446a.6.6,0,0,0-.46-.588.491.491,0,1,0-.261.947l-.046-.02-.176-.176c-.081-.121-.033-.242-.036-.137v20.33c0,.278-.013.558,0,.836v.036l.49-.49h-4.758l.49.49V254.82c0-.277.013-.558,0-.836-.006-.1.049.013-.036.14l-.176.176c-.144.1-.235.029-.147.036.033,0,.065,0,.1,0h4.428a.49.49,0,0,0,0-.98Z",
    transform: "translate(-451.978 -253.356)",
    fill: "#f45e29"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37820",
    "data-name": "Group 37820",
    transform: "translate(22.215 10.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52937",
    "data-name": "Path 52937",
    d: "M723.056,368.4H718.5a.1.1,0,0,0-.1.1v17.973h4.758V368.5A.1.1,0,0,0,723.056,368.4Z",
    transform: "translate(-717.907 -367.903)",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37819",
    "data-name": "Group 37819",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52938",
    "data-name": "Path 52938",
    d: "M708.456,353.185h-3.732c-.271,0-.545-.016-.813,0-.683.036-.6.669-.6,1.14V370.6c0,.366-.007.731,0,1.094v.049a.5.5,0,0,0,.49.49h4.758a.5.5,0,0,0,.49-.49V355.83c0-.679.026-1.368,0-2.047a.6.6,0,0,0-.46-.584.491.491,0,1,0-.261.947l-.046-.02-.177-.176c-.085-.127-.033-.238-.036-.144v17.205c0,.232-.013.47,0,.7v.033l.49-.49H703.8l.49.49V354.507c0-.232.013-.47,0-.7-.007-.095.052.013-.036.144l-.177.176c-.143.1-.235.029-.147.036a.97.97,0,0,0,.1,0h4.428a.488.488,0,1,0,0-.976Z",
    transform: "translate(-703.307 -353.178)",
    fill: "#f45e29"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37822",
    "data-name": "Group 37822",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37821",
    "data-name": "Group 37821",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52939",
    "data-name": "Path 52939",
    d: "M111.213,110.783H83.777c-.37,0-.743-.01-1.117,0h-.049l.7.7V84.046c0-.373.007-.743,0-1.117v-.049a.7.7,0,1,0-1.4,0v27.435c0,.373-.007.743,0,1.117v.049a.709.709,0,0,0,.7.7h27.435c.373,0,.743.007,1.117,0h.049a.7.7,0,1,0,0-1.4Z",
    transform: "translate(-81.911 -82.182)",
    fill: "#f45e29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graph-icon.99463eb4.svg";
export { ForwardRef as ReactComponent };